class BackInStock extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");

    this.addSubmitListener();
  }

  addSubmitListener() {
    this.form.addEventListener("submit", event => {
      event.preventDefault();

      this.input = this.querySelector(".js-input-email");
      this.email = this.input.value;
      this.variant = this.input.dataset.variant;

      if (this.email) this.submit();
      else this.displayErrorMessage("email");
    });
  }

  submit() {
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": this.email,
              }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::" + this.variant
            }
          }
        }
      }
    }

    this.postRequest("back-in-stock-subscriptions", payload)
      .then(() => this.submitSubscription())
      .then(() => this.displayMessage())
      .catch(error => this.handleError(error));
  }

  postRequest(type, payload) {
    const url = `https://a.klaviyo.com/client/${type}/?company_id=${window.apps.klaviyo_id}`;
    const requestOptions = {
      method: 'POST',
      headers: { "Content-Type": "application/json", "revision": "2024-07-15" },
      body: JSON.stringify(payload),
    };

    return fetch(url, requestOptions);
  }

  submitSubscription() {
    const input = this.querySelector(".js-input-consent");
    const payload = {
      data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: this.email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: `${window.apps.klaviyo_list_id}`
              }
            }
          }
        }
    };

    input.checked
      ? this.postRequest("subscriptions", payload)
      : Promise.resolve();
  }

  displayMessage() {
    const element = this.querySelector(".back-in-stock__success");

    if (element) element.classList.add("back-in-stock__success--active");

    this.removeErrorMessages();
  }

  displayErrorMessage(type) {
    const modifier = type === "email" ? "--email" : "";
    const element = this.querySelector(".back-in-stock__error" + modifier);

    if (element) element.classList.add("back-in-stock__error--active");
  }

  handleError(error) {
    this.displayErrorMessage();
  }

  removeErrorMessages() {
    const errors = this.querySelectorAll(".back-in-stock__error");

    errors.forEach(error => error.classList.remove("back-in-stock__error--active"));
  }
}

customElements.define("back-in-stock", BackInStock);